import { createAction } from '@reduxjs/toolkit'

export const setTransactionErrorMessage = createAction<{ errorMessage: string }>(
  'checkout/transaction/errorMessage/set'
)
